import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormMixin } from '../../mixins/components/FormMixin';

/**
 * An HTML [form element](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
 * The component itself does nothing other than provide layout for nested form components.
 *
 * @related ['FormActions']
 * @since 8.0.0
 */
var Form = /*#__PURE__*/styled.form.withConfig({
  displayName: "Form",
  componentId: "c11n-8-107-0__sc-iqxs9k-0"
})(["", ""], FormMixin);
Form.displayName = 'Form';
Form.propTypes = {
  /**
   * You can change the type of the component using the styled-components
   * [polymorphic "as" prop](https://www.styled-components.com/docs/api#as-polymorphic-prop).
   *
   * By default, this is a `"form"`, but you may want to change this to `"section"` or `"div"` if
   * you only want form layout without the native form functionality of `onSubmit`.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: PropTypes.any
};
Form.defaultProps = {
  as: 'form'
};

/** @component */
export { Form };